export default __webpack_public_path__ + "commercial_mf18f25.jpg";